<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6 form-group">
      <label>{{ 'dataconnection.name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls.name"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'dataconnection.identifier' | translate }}</label>
      <app-input-with-error [control]="this.form.controls.identifier"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group mt-2 mb-2">
      <app-input-with-error [control]="this.form.controls.treatAsOneJob" [inputType]="'checkbox'" description="dataconnection.treatAsOneJob"></app-input-with-error>
      <div class="form-text mt-0">{{ 'dataconnection.treatAsOneJob?' | translate }}</div>
    </div>
    <div class="col-md-6 form-group mt-2 mb-2">
      <app-input-with-error [control]="this.form.controls.defaultClearExisting" [inputType]="'checkbox'" description="dataconnection.defaultClearExisting"></app-input-with-error>
      <div class="form-text mt-0">{{ 'dataconnection.defaultClearExisting?' | translate }}</div>
    </div>
    <div class="col-md-12 form-group mb-2">
      <label>{{ 'dataconnection.description' | translate }}</label>
      <app-input-with-error inputType="textarea" rows="1" [control]="this.form.controls.description"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'dataconnection.template.singular' | translate }}</label>
      <app-input-with-error inputType="textarea" rows="3" [control]="this.form.controls.dataTemplate"></app-input-with-error>
    </div>
    <app-dataconnection-configuration #config [control]="form.controls.configuration" />
  </div>
</form>
